import { useRouter } from "next/router";
import Head from "next/head";

import { request } from "graphql-request"

import emailjs from 'emailjs-com';
import Layout from "../components/layout";
import styles from '../styles/fractional.module.scss'
import Form from 'react-bootstrap/Form';
import ReactMarkdown from "react-markdown";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Image from 'next/image'
import {
  GET_MENU_YACHTS,
  GET_FOOTER,
  GET_LATEST_YACHTS
} from "../lib/queries";
import { useState, useRef, useEffect } from "react";
import { usePathname } from 'next/navigation'

import { Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import FsLightbox from "fslightbox-react";

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { useForm } from "react-hook-form";
import Button from 'react-bootstrap/Button';

import Accordion from 'react-bootstrap/Accordion';

import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(useGSAP)


export async function getServerSideProps(context) {
    try{
      const { locale } = context;
  
      const { yachts } = await request(
        process.env.STRAPI_GRAPHQL_ENDPOINT,
        GET_MENU_YACHTS,
        { locale: locale },
      )
      const { footer } = await request(
        process.env.STRAPI_GRAPHQL_ENDPOINT,
        GET_FOOTER,
        { locale: locale },
      )
      const { yachts: latestYachts} = await request(
        process.env.STRAPI_GRAPHQL_ENDPOINT,
        GET_LATEST_YACHTS,
        { locale: locale },
      )
    
      const response = await fetch(`https://yachting-mexico.herokuapp.com/fractional?_locale=${locale}`);
      const fractional = await response.json();
    
      if ( !footer || !latestYachts || !fractional ) {
        return {
          notFound: true,
        };
      }
    
      return {
        props: {
          data: fractional,
          navbar: yachts,
          footer,
          latestYachts
        },
      };
    }catch(e){
      return {
        notFound: true,
      };
    }
    
  }
  
  const Fractional = ({ data, navbar, footer, latestYachts }) => {
    const router = useRouter();

    const bannerText = data.bannerText
    const bannerImage = data.bannerImage
    const bannerButton = data.bannerButton
    const pathname = router.locale == 'es'  ? '/es'+usePathname() : usePathname()
   
    const aboutImages = data.aboutImages
    const aboutText = data.aboutText
    const aboutButton = data.aboutButton

    const benefitsText = data.benefitsText
    const benefits = data.benefit  

    const yachtsText = data.yachtsText
    const yachts = data.yachts

    

    const formText = data.formText;
    const contactText = data.contactText
    const contactMail = data.contactMail
    const contactPhone = data.contactPhone
    const contactFile = data.contactFile
    const contactButton = data.contactButton

    const faqText = data.faqText
    const faqList = data.faqItem

    const form = useRef();
    const [contactStatus, setContactStatus] = useState(false)
    const { register, handleSubmit, reset, getValues, formState: { errors }} = useForm();
    const [disabled, setDisabled] = useState(true);

    const [toggler, setToggler] = useState(false);
    const [slide, setSlide] = useState(1);

   

    

    const openLightbox = (index) => {
      setSlide(index + 1);
      setToggler(!toggler);
    }


    const handleRequired = (e) => {
      let inputs = Object.values(getValues())
      
      let invalids = inputs.filter(item => item == '')
      if(invalids.length < 1)
        setDisabled(false)
      else
        setDisabled(true)
    }

    const onSubmit = (data) => { 
    
      setContactStatus("waiting");
      emailjs.send(process.env.NEXT_PUBLIC_EMAILJS_SERVICE, process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE, data, process.env.NEXT_PUBLIC_EMAILJS_USER)
          .then(() => {
            setContactStatus("sent");
            setTimeout(setContactStatus(false), 3000);
            setShow(true);
            reset({
              user_name: '',
              user_phone: '',
              user_email: '',
              user_message : ''
            })
            setName(data.user_name)
            
            try{
              fbq.event('Lead',{value: slug})
              const link = document.createElement('a');
              const msg = router.locale == 'es' ? 'Hola, estoy interesado en Fractional' : "Hello, I'm interested in Fractional";
              link.href = 'https://wa.me/'+contactPhone.replace(/\s/g, "")+'/?text='+ msg;
            
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

            }catch(e){
              console.log(e)
            }
          }, (error) => {
            console.error(error)
            setContactStatus("error");
          });
      
    };

    const handleDownload = async() =>{
      
  
      try {
        const response = await fetch(contactFile.url);
        const blob = await response.blob();
  
        // Crea un objeto URL para el blob
        const blobUrl = window.URL.createObjectURL(blob);
  
        // Crea un enlace temporal
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = contactFile.name; // Puedes cambiar el nombre del archivo aquí si es necesario
  
        // Simula el clic en el enlace
        document.body.appendChild(link);
        link.click();
  
        // Limpia el enlace temporal después de la descarga
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error al descargar el archivo:', error);
      }
    }

    const handlePhone = () =>{
      const link = document.createElement('a');
      link.href = 'tel:'+contactPhone;
    
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    const handleMail = () =>{
      const link = document.createElement('a');
      link.href = 'mailto:'+contactMail;
    
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }


    useGSAP(
      
      () => {
          import('gsap/ScrollTrigger').then(({ ScrollTrigger }) => {
          gsap.registerPlugin(ScrollTrigger);
          
    
          // Setup GSAP animation
          // gsap code here...
          gsap.to('.parallax', { 
            scale: 1.5,
            translateY: '+65%',
            scrollTrigger:{
              trigger: '.fractional-about',
              scrub: 1,
              end: '75%',
              start: '-=50%',
            }
          }); // <-- automatically reverted
        });
          
      }
    ); 
  
  
    return (
      <Layout header={navbar} footer={footer} latestYachts={latestYachts}>
        <Head>
          <title>Fractional Mexico | Yachting Mexico</title>
        </Head>
  
        <section className={styles.banner}> 
          <Image src={bannerImage[0].url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_1400/yachting-')} className={styles.bannerImage} alt={bannerImage[0].name} layout="fill"/>

          <div className={styles.bannerTextWrapper}> 
            <ReactMarkdown className={styles.bannerText}>{bannerText}</ReactMarkdown>
            <a className={styles.button} href={pathname+'#yachts'}>{bannerButton}</a>
          </div>

        </section>

        <section className={`${styles.about} fractional-about`}>
          {
            aboutImages.map((item, index) => (
              <Image 
                key={index} // Asegúrate de proporcionar una clave única para cada imagen
                src={item.url}
                layout="fill"
                loading="lazy"
                className={index !== 0 ? "parallax" : ""}
              />
            ))
            
          }
          <div className={styles.aboutText}>
            <ReactMarkdown>{aboutText}</ReactMarkdown>
            <a className={styles.buttonPrimary} href={pathname+'#contact'}>{aboutButton}</a>
          </div>

        </section>

        <section className={styles.benefits}>
          <ReactMarkdown className={styles.benefitsText}>{benefitsText}</ReactMarkdown>
          {
            benefits.map((item, index) => (
              <div className={styles.benefitsItem}>
                <Image src={item.icon.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_600/yachting-')} width='50' height='50' loading="lazy" />
                <ReactMarkdown className={styles.benefitsItemText}>{router.locale == 'es' ? item.textEs : item.text}</ReactMarkdown>

              </div>
            ))
            
          }
        </section>

        <section className={styles.yachts} id='yachts'>
          <ReactMarkdown className={styles.yachtsText}>{yachtsText}</ReactMarkdown>
          <Tabs className="justify-content-center">
            {
              yachts.map((item, index) => (
                
                <Tab  eventKey={item.name} title={item.name} key={index}>
                  <div className={styles.yachtsItem}>
                    <div className={styles.yachtsItemInfo}>
                      <h3>{item.name}</h3>  
                      {router.locale == 'es' ? item.infoEs : item.info}
                      
                      <strong>{ router.locale == 'es' ? 'Caracteristicas:' : 'Features:'  }</strong>
                      <div className={styles.yachtsItemFeatures}>
                        {
                          item.modelsFeature.map((feature,idx)=>(
                            <div className={styles.yachtsItemFeature}>
                             <p>{router.locale == 'es' ? feature.nameEs : feature.name}: <small>{feature.value}</small></p> 
                            </div>
                           
                          ))
                        }
                      </div>
                    </div>

                    <Swiper 
                      pagination={true} 
                      modules={[Pagination,Navigation]} 
                      className={styles.yachtsItemImages} 
                      style={{ '--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff', '--swiper-pagination-bullet-inactive-color': '#fff', '--swiper-pagination-bullet-inactive-opacity': '0.5', '--swiper-navigation-size': '20px'}}
                      autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                      }}
                     
                      navigation={true}
                    >
                      {item.images.map((image, idx) => (
                          <SwiperSlide key={idx} > 
                              <img src={image.url.replace(/upload\/[a-z0-9]*\/yachting-/gm, 'upload/w_1000/yachting-')} alt={image.name} loading="lazy" onClick={() => openLightbox(idx)}/>
                          </SwiperSlide>
                        ))
                      }
                    
                    </Swiper>

                    <FsLightbox
                      toggler={toggler}
                      sources={item.images.map(image => image.url)} 
                      slide={slide}
                    />

                  </div>
                  
                </Tab>
              ))
              
            }
          </Tabs>
           
        </section>

        <section className={styles.contact} id="contact">
          <div className={styles.contactInfo}>
            <ReactMarkdown>{contactText}</ReactMarkdown>
            <div onClick={()=>handlePhone()} className={styles.contactPhone}>{contactPhone}</div>
            <div onClick={()=>handleMail()} className={styles.contactMail}>{contactMail}</div>
           
            <a className={styles.button} onClick={handleDownload}>{contactButton}</a>
          </div>

          {Boolean(contactStatus !== "sent" && contactStatus !== "error") && (
            <>
              

              <form id="yachtForm" className={styles.contactForm} onSubmit={handleSubmit(onSubmit)} ref={form}>
                <h3>
                  {router.locale === "es"
                    ? "Agenda una cita"
                    : "Schedule your appointment"}
                </h3>
                <div className="mb-1 contact-input">
                  <label for="user_name" className={styles.labelInput}>{router.locale === "es" ? "Nombre" : "Your Name"}</label>
                  <input
                    type="text"
                    className='form-control'
                    name="user_name"
                    {...register("user_name", {
                      required: true,
                      onChange: handleRequired
                      })
                    }
                  />
                  {
                    errors.user_name && errors.user_name.type === 'required' && (
                    <span >
                      {router.locale === "es" ? "Ingresa tu nombre" : "Write your name"}
                    </span>
                    )
                  }
                </div>

                <div className="mb-1 contact-input" >
                  <label for="user_phone" className={styles.labelInput}>{router.locale === "es" ? "Teléfono" : "Phone"}</label>
                  <input
                    type="phone"
                    className='form-control'
                    name="user_phone"
                    
                    {...register("user_phone", {
                      required: true,
                      onChange: handleRequired,
                      pattern: {
                        value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                      }
                      })
                    }
                  />
                  {
                      errors.user_phone && errors.user_phone.type === 'required' && (
                    <span>
                      {router.locale === "es" ? "Ingresa un teléfono válido" : "Write a valid phone"}
                    </span>
                      )
                  }
                </div>

                <div className="mb-1 contact-input" >
                  <label for="user_email" className={styles.labelInput}>{router.locale === "es" ? "Correo" : "Mail"}</label>
                  <input
                    type="email"
                    className='form-control'
                    name="user_email"
                    
                    {...register("user_email", {
                      required: true,
                      onChange: handleRequired,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      }
                      })
                    }
                  />
                  {
                      errors.user_email && errors.user_email.type === 'required' && (
                    <span>
                      {router.locale === "es" ? "Ingresa un correo válido" : "Write a valid email"}
                    </span>
                      )
                  }
                </div>

                <div className="mb-3 contact-input ">
                  <label for="user_message" className={styles.labelInput}>{router.locale === "es" ? "Mensaje" : "Message"}</label>
                  <textarea
                    rows={5}
                    className='form-control'
                    name="user_message"
                    {...register("user_message", {
                      required: "required",
                      onChange: handleRequired
                      })
                    }
                  />
                  {
                    errors.user_message && errors.user_message.type === 'required' && (
                    <span>
                      {router.locale === "es" ? "Cuéntanos algo" : "Tell us something"}
                    </span>
                    )
                  }
                </div>

                
                <Button
                  disabled = { disabled }
                  variant="primary"
                  type="submit"
                  className="w-100"
                >
                  {!contactStatus
                    ? router.locale === "es" ? "Agendar visita" : "Schedule appointment"
                    : contactStatus === "waiting"
                      ? router.locale === "es" ? "Enviando..." : "Sending..."
                      : contactStatus === "sent"
                        ? router.locale === "es" ? "Mensaje enviado" : "Message sent"
                        : router.locale === "es" ? "Intenta de nuevo" : "Try again"
                  }
                </Button>
              </form>
            </>
          )}
          {contactStatus === "error" &&
            <Col md={12}>
              <div >
                <div className={styles.contact_error}>
                  <div className="error-image">
                    <ErrorForm />
                  </div>
                  <div style={{ fontSize: "32px" }}>
                    {
                      router.locale === "es" ? "¡Lo sentimos!" : "Sorry!"
                    }
                  </div>
                  <div className="error-message">
                    {
                      router.locale === "es"
                        ? "Ocurrió un error al enviar tu mensaje, por favor intenta de nuevo o ponte en contacto con nosotros directamente."
                        : "There was an error while sending your message, please try again later or contact us directly."
                    }
                  </div>

                  <Button
                    type="submit"
                    variant="primary"
                    className="w-100 mt-4 py-3 fw-bold text-uppercase"
                    onClick={() => { setContactStatus(undefined) }}
                  >
                    {router.locale === "es" ? "Intentar de nuevo" : "Try again"}
                  </Button>
                </div>
              </div>
            </Col>
          }

        </section>

        <section className={styles.faq}>
          <ReactMarkdown className={styles.faqText}>{faqText}</ReactMarkdown>
          <Accordion defaultActiveKey="0">
            {faqList.map((item,idx)=>(
              <Accordion.Item eventKey={idx}>
                <Accordion.Header className={styles.faqItemHeader}>{item.question}</Accordion.Header>
                <Accordion.Body>
                  <ReactMarkdown>{item.answer}</ReactMarkdown>
                </Accordion.Body>
              </Accordion.Item>
            ))

            }
            
          </Accordion>

        </section>
  
      </Layout>
    );
  };

  
  export default Fractional;